import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const EventDataSlice = createSlice({
    name: "events",
    initialState,
    reducers: {
        getEventsRequest(state) {
            state.loading = true;
        },
        getEventsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getEventsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getEventsRequest,
    getEventsRequestSuccess,
    getEventsRequestError,
} = EventDataSlice.actions;

export default EventDataSlice.reducer;
